// exit-popup.js
(function () {
  'use strict';

  // -- Config -----------------------------------
  var STORAGE_KEY = 'ep_dismissed';
  var COOLDOWN_DAYS = 7;
  var DELAY_MS = 30000;
  var MOUSE_THRESHOLD = 20;

  // -- Elements ---------------------------------
  var overlay = document.getElementById('exitPopupOverlay');
  var popup = document.getElementById('exitPopup');
  var closeBtn = document.getElementById('exitPopupClose');
  var declineBtn = document.getElementById('exitPopupDecline');
  var form = document.getElementById('ExitPopupForm');
  var emailInput = document.getElementById('ExitPopupEmail');
  var errorEl = document.getElementById('exitPopupError');
  var successEl = document.getElementById('exitPopupSuccess');

  if (!overlay || !popup || !form || !emailInput || !errorEl || !successEl) return;

  // -- Check cooldown ---------------------------
  function shouldShow() {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return true;
    var dismissedAt = parseInt(stored, 10);
    if (isNaN(dismissedAt)) return true;
    var daysSince = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);
    return daysSince >= COOLDOWN_DAYS;
  }

  // -- Show popup -------------------------------
  function showPopup() {
    if (!shouldShow()) return;
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    window.setTimeout(function () {
      emailInput.focus();
    }, 400);
    document.removeEventListener('mouseleave', onMouseLeave);
    clearTimeout(timerTrigger);
  }

  // -- Hide popup -------------------------------
  function hidePopup() {
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }

  // -- Exit intent ------------------------------
  function onMouseLeave(e) {
    if (e.clientY <= MOUSE_THRESHOLD) {
      showPopup();
    }
  }

  // -- Time fallback trigger --------------------
  var timerTrigger = setTimeout(showPopup, DELAY_MS);

  // -- Close handlers ---------------------------
  if (closeBtn) closeBtn.addEventListener('click', hidePopup);
  if (declineBtn) declineBtn.addEventListener('click', hidePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) hidePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
      hidePopup();
    }
  });

  // -- Form submission --------------------------
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorEl.textContent = '';
    emailInput.classList.remove('has-error');

    var email = emailInput.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.textContent = 'Please enter a valid email address.';
      emailInput.classList.add('has-error');
      emailInput.focus();
      return;
    }

    var formData = new FormData(form);
    fetch('/contact', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function () {
        showSuccess();
      })
      .catch(function () {
        showSuccess();
      });
  });

  function showSuccess() {
    popup.classList.add('exit-popup--success');
    successEl.classList.add('is-visible');
    successEl.removeAttribute('aria-hidden');

    setTimeout(function () {
      hidePopup();
      setTimeout(function () {
        popup.classList.remove('exit-popup--success');
        successEl.classList.remove('is-visible');
        successEl.setAttribute('aria-hidden', 'true');
        form.reset();
        emailInput.classList.remove('has-error');
        errorEl.textContent = '';
      }, 400);
    }, 4000);
  }

  // -- Init -------------------------------------
  if (shouldShow()) {
    document.addEventListener('mouseleave', onMouseLeave);
  }
})();
